# Canvas

## <v-icon>mdi-location-exit</v-icon> Cue/Take

Cue/Take allows you to broadcast scenes in different frames (with different channels) at the same time allowing you to synchronize content across frames.

To cue a scene, drag a Scene from a Queue into the '<v-icon>mdi-blur</v-icon> Canvas' Area, you will get a notification and the Canvas Preview will now say '<v-icon>mdi-location-exit</v-icon> Cued 1 Scene' in the bottom left.

You can also cue a queue in the same way if desired

Once you have queued at least 1 Scene or Queue, open the Canvas (by clicking on it and) click <v-btn prepend-icon='mdi-location-exit' color='primary'>TAKE</v-btn> to start the Take.

## <v-icon>mdi-cctv</v-icon> Change Canvas Preview

By default the Canvas displays your Canvas as output in your graphics engine (while it's running).

The Canvas preview fully supports displaying MJPEG streams allowing you to optionally change it to an IP Camera stream:

- Create a new live stream asset with the IP Camera MJPEG URL (including the username and password if required)
- Select the Asset from the dropdown, then click <v-btn prepend-icon='mdi-content-save' color='primary'>save</v-btn>
- The Canvas Preview will now display your Live Stream instead.
